<template>
  <el-card>
    <el-dialog
      title="Detalle de Ejecucion de Presupuesto"
      :visible.sync="isVisible"
      @close="onCloseExecutionDetail"
    >
      <rabbey-table-3
        :data="ExecutionDetailData"
        :columns="ExecutionDetailColumns"
        :actions="Actions"
        @rtable-push-action="ActionHandler"
      />
    </el-dialog>
  </el-card>
</template>

<script>
//import { ActionHandler } from '@/components/activity_flow/DialogLocker/TaskPendingToApprove'

export default {
  name: "budgetExecutionDetail",
  props: {
    executionDetailVisibility: Boolean,
    rowProps: Object
  },
  data() {
    return {
      //GoalProp: "",
      //ExecutedProp: "",
      tableData: [],
      tableColumns: [
        {
          prop: "cuenta",
          name: "Cuenta",
          label: "Cuenta",
          minWidth: 120,
          fixed: true
          //formatter: HyperlinkForBugedtExecution
        },
        {
          prop: "nombre",
          name: "Nombre Cuenta",
          label: "Nombre Cuenta",
          minWidth: 250,
          fixed: true
          //formatter: HyperlinkForBugedtExecution
        },

        {
          prop: "ene",
          name: "Enero",
          label: "Enero",
          minWidth: 150
          /*
    cellAtrrs: {
      mes: 1,
      editEneable: false, // thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    */
          //formatter: HyperlinkForBugedtExecution
        },
        {
          prop: "feb",
          name: "Febrero",
          label: "Febrero",
          minWidth: 150
          /*
    cellAtrrs: {
      mes: 2,
      editEneable: false, // thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    */
          //formatter: HyperlinkForBugedtExecution
        },
        {
          prop: "mar",
          name: "Marzo",
          label: "Marzo",
          minWidth: 150
          /*
    cellAtrrs: {
      mes: 3,
      editEneable: false, // thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    */
          //formatter: HyperlinkForBugedtExecution
        },
        {
          prop: "abr",
          name: "Abril",
          label: "Abril",
          minWidth: 150
          /*
    cellAtrrs: {
      mes: 4,
      editEneable: false, // thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    */
          //formatter: HyperlinkForBugedtExecution
        },
        {
          prop: "may",
          name: "Mayo",
          label: "Mayo",
          minWidth: 150
          /*
    cellAtrrs: {
      mes: 5,
      editEneable: false, // thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    */
          //formatter: HyperlinkForBugedtExecution
        },
        {
          prop: "jun",
          name: "Junio",
          label: "Junio",
          minWidth: 150
          /*
    cellAtrrs: {
      mes: 6,
      editEneable: false, // thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    */
          //formatter: HyperlinkForBugedtExecution
        },
        {
          prop: "jul",
          name: "Julio",
          label: "Julio",
          minWidth: 150
          /*
    cellAtrrs: {
      mes: 7,
      editEneable: false, // thiss.editEneable,
      mes2: "July",
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    */
          //formatter: HyperlinkForBugedtExecution
        },
        {
          prop: "ago",
          name: "Agosto",
          label: "Agosto",
          minWidth: 150
          /*
    cellAtrrs: {
      mes: 8,
      editEneable: false, // thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    */
          //formatter: HyperlinkForBugedtExecution
        },
        {
          prop: "sep",
          name: "Septiembre",
          label: "Septiembre",
          /*
    cellAtrrs: {
      mes: 9,
      editEneable: false, // thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    */
          minWidth: 150
          //formatter: HyperlinkForBugedtExecution
        },
        {
          prop: "oct",
          name: "Octubre",
          label: "Octubre",
          /*
    cellAtrrs: {
      mes: 10,
      editEneable: false, // thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    */
          minWidth: 150
          //formatter: HyperlinkForBugedtExecution
        },
        {
          prop: "nov",
          name: "Noviembre",
          label: "Noviembre",
          /*
    cellAtrrs: {
      mes: 11,
      editEneable: false, // thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    */
          minWidth: 150
          //formatter: HyperlinkForBugedtExecution
        },
        {
          prop: "dic",
          name: "Diciembre",
          label: "Diciembre",
          /*
    cellAtrrs: {
      mes: 12,
      editEneable: false, // thiss.editEneable,
      updatingAccountValue: thiss.updatingAccountValue,
      OpenDetail: thiss.openExecutionDetail
    },
    */
          minWidth: 150
          //formatter: HyperlinkForBugedtExecution
        },
        {
          prop: "tot",
          name: "Total",
          label: "Total",
          minWidth: 150,
          fixed: "right"
          //formatter: HyperlinkForBugedtExecution
        }
      ],
      Actions: [
        {
          icon: "el-icon-edit",
          label: "Editar Meta",
          command: "edit-amount-acc"
          //condition: (row) => row.negrita !== "S" && row.negrita !== "T"
        }
      ]
    };
  },
  computed: {
    isVisible() {
      return this.executionDetailVisibility;
    },
    GoalProp() {
      let GoalProp = "";
      GoalProp = this.rowProps.column + "BG";
      return GoalProp;
    },
    ExecutedProp() {
      let ExecutedProp = "";
      ExecutedProp = this.rowProps.column + "RS";
      return ExecutedProp;
    },
    ExecutionDetailData() {
      let executionData = [];
      //let GoalProp = this.GoalProp
      // let ExecutedProp = this.
      //console.log(this.GoalProp, this.ExecutedProp)
      //console.log("rowProps in Data", this.rowProps)
      //executionData = (({GoalProp = this.GoalProp, ExecutedProp = this.ExecutedProp}) => ({GoalProp, ExecutedProp}))(this.rowProps.row)
      executionData.push(this.rowProps.row);
      //console.log("executionData: ", executionData)
      return executionData;
    },
    ExecutionDetailColumns() {
      let executionColumns = [];
      //console.log("rowProps in Columns", this.rowProps)
      //console.log(this.GoalProp, this.ExecutedProp)
      executionColumns = this.tableColumns.filter(
        (c) =>
          c.prop === "cuenta" ||
          c.prop === "nombre" ||
          c.prop === this.GoalProp ||
          c.prop === this.ExecutedProp
      );
      executionColumns.push(
        {
          prop: this.GoalProp,
          name: "Meta",
          label: "Meta",
          minWidth: 150
          /*
          cellAtrrs: {
            mes: 1,
            editEneable: false, // thiss.editEneable,
            updatingAccountValue: thiss.updatingAccountValue,
            OpenDetail: thiss.openExecutionDetail
          },
          */
          //formatter: HyperlinkForBugedtExecution
        },
        {
          prop: this.ExecutedProp,
          name: "Ejecutado",
          label: "Ejecutado",
          minWidth: 150
          /*
          cellAtrrs: {
            mes: 1,
            editEneable: false, // thiss.editEneable,
            updatingAccountValue: thiss.updatingAccountValue,
            OpenDetail: thiss.openExecutionDetail
          },
          */
          //formatter: HyperlinkForBugedtExecution
        }
      );
      //console.log("executionColumns", executionColumns)
      return executionColumns;
    }
  },
  methods: {
    onCloseExecutionDetail() {
      this.$emit("onCloseExecutionDetail");
    },
    async ActionHandler(action) {
      //console.log("action: ", action)

      this.$prompt(
        "Por favor introduzca el nuevo monto para la meta",
        "Modificacion de Meta",
        {
          confirmButtonText: "Proceder",
          cancelButtonText: "Cancelar",
          inputType: "number",
          inputValidator: this.inputValidate
          /*
          inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          inputErrorMessage: 'Invalid Email'
          */
        }
      )
        .then(async ({ value }) => {
          let newValue = parseFloat(value).toFixed(2);
          const params = {
            newAmount: newValue,
            accountNo: action.row.cuenta,
            month: this.rowProps.mes,
            year: this.rowProps.year,
            option: this.rowProps.valueCompany
          };
          //console.log("rowValue: ",action.row[this.GoalProp])
          if (action.row[this.GoalProp] !== null) {
            await this.$http
              .put("/api/resultsStatus/UpdateBudgetAccValue", params)
              .then((resp) => {
                resp;
                //console.log("Updating", resp)
                if (resp.data > 0) {
                  this.$emit("BudgetAccUpdated");
                  this.$message({
                    showClose: true,
                    message: "El nuevo valor para la meta fue agregado:!",
                    type: "success"
                  });
                }
              })
              .catch((err) => {
                console.error(err);
              });
          } else {
            await this.$http
              .post("/api/resultsStatus/InsertNewBudgetMovement", params)
              .then((resp) => {
                resp;
                //console.log("inserting", resp)
                if (resp.data > 0) {
                  this.$emit("BudgetAccUpdated");
                  this.$message({
                    showClose: true,
                    message: "El nuevo valor para la meta fue agregado:!",
                    type: "success"
                  });
                }
              })
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Operacion cancelada"
          });
        });
      /*
        
      */
    },
    inputValidate(value) {
      //console.log("inputValidate: ",value)
      if (value !== null && value !== "") {
        return true;
      } else {
        return "Debe introducir un nuevo monto para la meta";
      }
    }
  }
};
</script>

<style scoped></style>
